'use client'

import { FunctionComponent, useState } from 'react'
import { CustomCmsCategory } from '../../../domain/cmsCategory'
import Image from '../Image/Image'
import { useTranslation } from '../../context/ConfigContext'
import clsx from 'clsx'
import { stripHtml } from '../../../core/hook/utils'

type HeaderCategoryProps = {
  contrast?: boolean
  cmsCategory: CustomCmsCategory
  className?: string
}

const HeaderCategoryMobile: FunctionComponent<HeaderCategoryProps> = ({
  cmsCategory,
  contrast = false,
  className,
}) => {
  const text = cmsCategory.short_description ?? ''
  const truncatedText = stripHtml(
    typeof text === 'string' ? text.substring(0, text.length / 2) : '',
  )

  const t = useTranslation()
  const [isExpanded, setIsExpanded] = useState(false)

  const handleToggle = () => {
    setIsExpanded(!isExpanded)
  }

  const subtitle = (
    <h2
    className={clsx('subtitle', { 'text-black': cmsCategory.description_color === 1})}
      dangerouslySetInnerHTML={{
        __html: `${cmsCategory.titlePrefix ?? ''} ${cmsCategory.name ?? ''} ${
          cmsCategory.titleSuffix ?? ''
        }`,
      }}
    />
  )

  return (
    <div
      className={clsx(
        `header-media header-media-category ${contrast ? 'contrast' : ''}`,
        className,
      )}>
      <div className='header-media-source'>
        <picture className='contrast'>
          <Image src={cmsCategory.mobileImage} alt='' size='s' priority={true} />
        </picture>
      </div>
      <div className='header-media-content'>
        <h1 className={clsx('title-h1', { 'text-black': cmsCategory.titleColor === 1})}>
          {`${cmsCategory.prefixCoverTitle ?? ''} ${cmsCategory.coverTitle ?? ''} ${
            cmsCategory.coverSecondTitle ?? ''
          }`}
        </h1>
        <div className='header-media-descr-wrapper'>
          {text.length > 100 ? (
            <>
              {isExpanded ? (
                <>
                  {subtitle}
                  <div 
                    className={clsx('descr', { 'text-black': cmsCategory.short_description_color === 1})} 
                    dangerouslySetInnerHTML={{ __html: text }}>
                  </div>
                </>
              ) : (
                <>
                  {subtitle}
                  <div
                    className={clsx('descr', { 'text-black': cmsCategory.short_description_color === 1})}
                    dangerouslySetInnerHTML={{ __html: `${truncatedText}... ` }}></div>
                </>
              )}

              {text.length > truncatedText.length && (
                <button className='btn-see-more' onClick={handleToggle}>
                  {isExpanded
                    ? t('catalog-category-header-see-less', {}, false)
                    : t('catalog-category-header-see-more', {}, false)}
                </button>
              )}
            </>
          ) : (
            <>
              {subtitle}
              <div 
                className={clsx('descr', { 'text-black': cmsCategory.short_description_color === 1})} 
                dangerouslySetInnerHTML={{ __html: text }}>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  )
}
export default HeaderCategoryMobile
